var map = {
	"./Tamilnadu-Assembly-NEW.svg": 178,
	"./action.svg": 207,
	"./adventure.svg": 208,
	"./advertorial.svg": 209,
	"./ai.svg": 210,
	"./album.svg": 211,
	"./analysis.svg": 212,
	"./anchor.svg": 213,
	"./android-block.svg": 214,
	"./android-small.svg": 215,
	"./android.svg": 216,
	"./angle-down.svg": 217,
	"./angle-left.svg": 218,
	"./angle-right.svg": 219,
	"./angle-up.svg": 220,
	"./aquarius.svg": 221,
	"./arcade.svg": 222,
	"./aries.svg": 223,
	"./arrow-down.svg": 224,
	"./arrow-left.svg": 225,
	"./arrow-right.svg": 226,
	"./arrow-up.svg": 227,
	"./arrow.svg": 228,
	"./art-director.svg": 229,
	"./astrology.svg": 230,
	"./author-avator.svg": 231,
	"./author.svg": 232,
	"./authoranchor.svg": 233,
	"./authorwhite.svg": 234,
	"./automobile.svg": 235,
	"./backward.svg": 236,
	"./bookmark.svg": 237,
	"./books-vikatan.svg": 238,
	"./brandconnect.svg": 239,
	"./breaking-news.svg": 240,
	"./bullet-arrow.svg": 241,
	"./bundle.svg": 242,
	"./business.svg": 243,
	"./calendar.svg": 244,
	"./cancel.svg": 245,
	"./cancer.svg": 246,
	"./canvas.svg": 247,
	"./capricorn.svg": 248,
	"./cartoonist.svg": 249,
	"./cinema.svg": 250,
	"./clapboard.svg": 251,
	"./clipboard.svg": 252,
	"./close.svg": 253,
	"./comment.svg": 254,
	"./corona-updates-icon.svg": 255,
	"./creative-director.svg": 256,
	"./cricket.svg": 257,
	"./crime.svg": 258,
	"./data.svg": 259,
	"./designed.svg": 260,
	"./double-arrow.svg": 261,
	"./downarrow.svg": 262,
	"./download.svg": 263,
	"./edit.svg": 264,
	"./edited-by.svg": 265,
	"./election-2026.svg": 266,
	"./email.svg": 267,
	"./environment.svg": 268,
	"./exclusivedeals.svg": 269,
	"./facebook-bg.svg": 270,
	"./facebook-icon.svg": 271,
	"./facebook.svg": 272,
	"./filter-icon.svg": 273,
	"./filter.svg": 274,
	"./food-stylist.svg": 275,
	"./forward.svg": 276,
	"./gallery.svg": 277,
	"./game-shop.svg": 278,
	"./gemini.svg": 279,
	"./group.svg": 280,
	"./gzhome.svg": 281,
	"./gzsports.svg": 282,
	"./gztrending.svg": 283,
	"./health.svg": 284,
	"./hexbackground.svg": 285,
	"./home.svg": 286,
	"./humoursatire-entertainment.svg": 287,
	"./icon-apple.svg": 288,
	"./icon-appstore.svg": 289,
	"./icon-audio-app-store.svg": 290,
	"./icon-audio-fb.svg": 291,
	"./icon-audio-instagram.svg": 292,
	"./icon-audio-next.svg": 293,
	"./icon-audio-play-store.svg": 294,
	"./icon-audio-previous.svg": 295,
	"./icon-audio-twitter.svg": 296,
	"./icon-audio-whatsapp.svg": 297,
	"./icon-copy.svg": 298,
	"./icon-election.svg": 299,
	"./icon-episode.svg": 300,
	"./icon-facebook.svg": 301,
	"./icon-google-play.svg": 302,
	"./icon-headset.svg": 303,
	"./icon-home-plus.svg": 304,
	"./icon-login.svg": 305,
	"./icon-open-in-new.svg": 306,
	"./icon-pause.svg": 307,
	"./icon-play.svg": 308,
	"./icon-playstore.svg": 309,
	"./icon-premium.svg": 310,
	"./icon-share.svg": 311,
	"./icon-star.svg": 312,
	"./icon-timer.svg": 313,
	"./icon-twitter.svg": 314,
	"./icon-user.svg": 315,
	"./icon-video.svg": 316,
	"./icon-whatsapp.svg": 317,
	"./illustrator-t1.svg": 318,
	"./illustrator.svg": 319,
	"./infographer.svg": 320,
	"./instagram.svg": 321,
	"./interviews.svg": 322,
	"./ios-block.svg": 323,
	"./ios-small.svg": 324,
	"./ios.svg": 325,
	"./jokes.svg": 326,
	"./leo.svg": 327,
	"./libra.svg": 328,
	"./lifestyle.svg": 329,
	"./line-arrow-next.svg": 330,
	"./line-arrow-prev.svg": 331,
	"./linkedin.svg": 332,
	"./listicle.svg": 333,
	"./live-chat.svg": 334,
	"./liveupdate.svg": 335,
	"./log green.svg": 336,
	"./log grey.svg": 337,
	"./log white.svg": 338,
	"./logic.svg": 339,
	"./login-facebook.svg": 340,
	"./login-google.svg": 341,
	"./login.svg": 342,
	"./logout-mobile.svg": 343,
	"./logout.svg": 344,
	"./longform.svg": 345,
	"./magazines.svg": 346,
	"./mail.svg": 347,
	"./menu-search.svg": 348,
	"./microphone.svg": 349,
	"./minus.svg": 350,
	"./mobile-share.svg": 351,
	"./moderated.svg": 352,
	"./more-outline.svg": 353,
	"./my-vikatan-logo.svg": 354,
	"./mynews.svg": 355,
	"./myvikatanbadge.svg": 356,
	"./narrated.svg": 357,
	"./news.svg": 358,
	"./newsletter.svg": 359,
	"./newslettericon.svg": 360,
	"./olympic.svg": 361,
	"./online-news.svg": 362,
	"./pause.svg": 363,
	"./pdf.svg": 364,
	"./pen.svg": 365,
	"./personalise.svg": 366,
	"./phone.svg": 367,
	"./photo.svg": 368,
	"./photographer.svg": 369,
	"./photostory.svg": 370,
	"./pisces.svg": 371,
	"./play.svg": 372,
	"./plus.svg": 373,
	"./podcast.svg": 374,
	"./podcast_vikatan_menu.svg": 375,
	"./poems.svg": 376,
	"./politics.svg": 377,
	"./premium.svg": 378,
	"./producer.svg": 379,
	"./proofread.svg": 380,
	"./published-by.svg": 381,
	"./published.svg": 382,
	"./rain.svg": 383,
	"./rss.svg": 384,
	"./rupee.svg": 385,
	"./sagitarius.svg": 386,
	"./scorpio.svg": 387,
	"./script-writer.svg": 388,
	"./scripted.svg": 389,
	"./search.svg": 390,
	"./share-alt.svg": 391,
	"./share.svg": 392,
	"./sharechat.svg": 393,
	"./shortform.svg": 394,
	"./shortstories.svg": 395,
	"./shortvideo.svg": 396,
	"./slider-next.svg": 397,
	"./slider-prev.svg": 398,
	"./socialshare.svg": 399,
	"./sort.svg": 400,
	"./sound.svg": 401,
	"./speaker.svg": 402,
	"./speakeraudio.svg": 403,
	"./spiritual.svg": 404,
	"./sponsored.svg": 405,
	"./sports.svg": 406,
	"./star.svg": 407,
	"./stories.svg": 408,
	"./strategy.svg": 409,
	"./stylist.svg": 410,
	"./subscribe-vikatan.svg": 411,
	"./success-icon.svg": 412,
	"./tag.svg": 413,
	"./tamilnadu.svg": 414,
	"./taurus.svg": 415,
	"./technology.svg": 416,
	"./text.svg": 417,
	"./textsms.svg": 418,
	"./thodargal.svg": 419,
	"./thump.svg": 420,
	"./tick.svg": 421,
	"./trending.svg": 422,
	"./twitter-icon.svg": 423,
	"./twitter.svg": 424,
	"./uparrow.svg": 425,
	"./update-black.svg": 426,
	"./user-square.svg": 427,
	"./user.svg": 428,
	"./v-plus-logo.svg": 429,
	"./video-editor.svg": 430,
	"./video-icon.svg": 431,
	"./video-play.svg": 432,
	"./video.svg": 433,
	"./videographer.svg": 434,
	"./vikatan-play-logo-red.svg": 435,
	"./vikatan-play.svg": 436,
	"./vikatan-tv.svg": 437,
	"./vikatan.svg": 438,
	"./vikatanconnect.svg": 439,
	"./vikatanplay.svg": 440,
	"./vikatanspl.svg": 441,
	"./vikatantv.svg": 442,
	"./virgo.svg": 443,
	"./whatsapp-icon.svg": 444,
	"./whatsapp-icon1.svg": 445,
	"./whatsapp.svg": 446,
	"./women-home.svg": 447,
	"./writtenarticles.svg": 448,
	"./writtenstory.svg": 449,
	"./youtube.svg": 450
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 206;